'use client';
import { useState, useEffect } from 'react';
import { tokensRaw } from '../../core/tokens/tokens-raw.js';

const isSafariVersion18 = ()=>{
    if ('undefined' == typeof window) return false;
    let { userAgent: e } = navigator, { vendor: r } = navigator;
    if (!(r && r.includes('Apple') && e.includes('Safari') && !e.includes('Chrome'))) return false;
    let { matches: n } = window.matchMedia(`(max-width: ${tokensRaw.SwanBaseBreakpointXsEnd})`), t = e.match(/Version\/(\d+(\.\d+)?)/);
    if (t && t[1]) {
        let r = parseFloat(t[1]);
        return r >= 18 && r < 18.2 && e.includes('iPhone') && n;
    }
    return false;
};
const useIsSafariVersion18 = ()=>{
    let [i, n] = useState(false);
    return useEffect(()=>{
        n(isSafariVersion18());
    }, []), i;
};

export { isSafariVersion18, useIsSafariVersion18 };
